/*
 * This file is auto-generated. Do not edit this file manually.
 * To regenerate this file, run the command:
 *   ./manage.py export_enums [path_to_frontend]
 */

export const ASSET_TYPE = {
  'ASSET_TYPE_WORKSTATION': 'Workstation',
  'ASSET_TYPE_PRINTER': 'Printer',
  'ASSET_TYPE_CREDIT_CARD_READER': 'Credit Card Reader',
  'ASSET_TYPE_MONITOR': 'Monitor',
};

export const ASSET_NO_WORKFLOW_ASSIGNED = 'no_workflow_assigned';
export const ASSET_NO_WORKFLOW_ASSIGNED_LABEL = 'No Workflow Assigned';

export const WORKFLOW_REQ_CATEGORY_MONITOR = 'Monitor';

export const PRINTER_TYPE_NETWORK = 'Network';
export const TENANT_CODE_URL_PARAMETER = 'tc';
export const PRINTER_TRAY_CONTENT_NAMES = {
  'PLAIN_PAPER': 'Plain Paper',
  'WRIST_BAND': 'Wrist Band',
  'BABY_WRIST_BAND': 'Baby Wrist Band',
  'PHARMACY_LABEL': 'Pharmacy Label',
  'LABEL': 'Label',
  'PRESCRIPTION': 'Prescription',
  'INSURANCE_FORM': 'Insurance Form',
};

export const DEFAULT_PRINTER_FIELD_MAP = {
  'PLAIN_PAPER': 'default_printer_plain_paper',
  'WRIST_BAND': 'default_printer_wristbands',
  'BABY_WRIST_BAND': 'default_printer_baby_wristbands',
  'PHARMACY_LABEL': 'default_printer_pharm_labels',
  'LABEL': 'default_printer_labels',
  'PRESCRIPTION': 'default_printer_scripts',
  'INSURANCE_FORM': 'default_printer_insurance_form',
};

export const MENU_SECTIONS = {
  'INVENTORY': 'inventory',
  'WORKSTATION': 'workstation',
  'COMMON': 'common',
};
export const MENU_SECTIONS_LABELS = {
  'inventory': 'Inventory',
  'workstation': 'Workstation',
  'common': 'Common',
};

export const USER_PERMISSIONS = {
  'USERS_MGT': 'common/users/mgt',
  'USERS_ROLES': 'common/users/role_mgt',
  'SETTINGS_MGT': 'common/settings/mgt',
  'FUNCTIONAL_TYPES_MGT': 'workstation/functional_types/mgt',
  'WORKSTATIONS_DUP_HISTORY': 'workstation/workstations/dup_history',
  'WORKSTATIONS_DUPLICATE': 'workstation/workstations/duplicate',
  'WORKSTATIONS_LIST': 'workstation/workstations/list',
  'FUNCTIONAL_TYPES_BULK_UPDATE': 'workstation/functional_types/bulk_update',
  'ASSETS_ADD': 'inventory/assets/add',
  'DROPDOWNS_MGT': 'inventory/dropdowns/mgt',
  'STATES_MGT': 'inventory/states/mgt',
  'CITIES_MGT': 'inventory/cities/mgt',
  'BUILDINGS_MGT': 'inventory/buildings/mgt',
  'OUS_MGT': 'inventory/ous/mgt',
  'SPECIALTIES_MGT': 'inventory/specialties/mgt',
  'DEPARTMENTS_MGT': 'inventory/departments/mgt',
  'WORKFLOWS_MGT': 'inventory/workflows/mgt',
  'WORKSTATION_AND_PRINTER_ASSETS_MGT': 'inventory/assets/workstation_and_printer_mgt',
  'ALL_ASSETS_MGT': 'inventory/assets/all_assets_mgt',
  'WORKSTATION_DEFAULT_PRINTERS_MGT': 'inventory/assets/workstation_default_printer_mgt',
  'LEASED_ASSETS_MGT': 'inventory/assets/leased_assets_mgt',
  'WORKSTATIONS_WO_PRIMARY_USE_REPORT': 'inventory/assets/workstations_wo_primary_use_report',
  'ASSETS_TO_FOLLOW_UP_REPORT': 'inventory/assets/assets_to_follow_up_report',
  'ALL_DOCUMENTS_REPORT': 'inventory/assets/all_documents_report',
  'ASSETS_TDR_NOT_PASSED_REPORT': 'inventory/assets/assets_tdr_not_passed_report',
  'GAP_REPORT': 'inventory/assets/gap_report',
  'UTH_LWS_REPORT': 'inventory/assets/uth_lws_report',
  'UTH_EPR_REPORT': 'inventory/assets/uth_epr_report',
  'LWS_CHANGES_REPORT': 'inventory/assets/lws_changes_report',
  'WORKFLOW_REQS_REPORT': 'inventory/workflows/workflow_reqs_report',
  'CLINIC_SUMMARY_REPORT': 'inventory/workflows/clinic_summary_report',
  'DROPDOWNS_BULK_UPDATE': 'inventory/dropdowns/bulk_update',
  'STATES_BULK_UPDATE': 'inventory/states/bulk_update',
  'CITIES_BULK_UPDATE': 'inventory/cities/bulk_update',
  'BUILDINGS_BULK_UPDATE': 'inventory/buildings/bulk_update',
  'OUS_BULK_UPDATE': 'inventory/ous/bulk_update',
  'SPECIALTIES_BULK_UPDATE': 'inventory/specialties/bulk_update',
  'DEPARTMENTS_BULK_UPDATE': 'inventory/departments/bulk_update',
  'WORKFLOWS_BULK_UPDATE': 'inventory/workflows/bulk_update',
  'WORKFLOW_DEFAULT_REQS_BULK_UPDATE': 'inventory/workflows/default_reqs_bulk_update',
  'ASSETS_ALL_BULK_UPDATE': 'inventory/assets/bulk_update',
  'WORKSTATIONS_BULK_UPDATE': 'inventory/assets/workstations_bulk_update',
  'LEASED_ASSETS_BULK_UPDATE': 'inventory/assets/leased_assets_bulk_update',
};

export const USER_PERMISSIONS_LABELS = {
  'common/users/mgt': 'Manage Users',
  'common/users/role_mgt': 'Manage User Roles',
  'common/settings/mgt': 'Manage Settings',
  'workstation/functional_types/mgt': 'Manage Functional Types',
  'workstation/workstations/dup_history': 'Workstation Duplication History',
  'workstation/workstations/duplicate': 'Duplicate Workstations',
  'workstation/workstations/list': 'List Workstations',
  'workstation/functional_types/bulk_update': 'Functional Types Bulk Update',
  'inventory/assets/add': 'Add Assets',
  'inventory/dropdowns/mgt': 'Manage Dropdowns List',
  'inventory/states/mgt': 'Manage States',
  'inventory/cities/mgt': 'Manage Cities',
  'inventory/buildings/mgt': 'Manage Buildings',
  'inventory/ous/mgt': 'Manage OUs',
  'inventory/specialties/mgt': 'Manage Specialties',
  'inventory/departments/mgt': 'Manage Departments',
  'inventory/workflows/mgt': 'Manage Primary Uses',
  'inventory/assets/workstation_and_printer_mgt': 'All Workstation and Printer Assets',
  'inventory/assets/all_assets_mgt': 'All Assets View',
  'inventory/assets/workstation_default_printer_mgt': 'All Default Printers',
  'inventory/assets/leased_assets_mgt': 'All Leased Assets',
  'inventory/assets/workstations_wo_primary_use_report': 'Workstations without Primary Use',
  'inventory/assets/assets_to_follow_up_report': 'Assets to Follow Up',
  'inventory/assets/all_documents_report': 'All Documents',
  'inventory/assets/assets_tdr_not_passed_report': 'Assets TDR Not Passed',
  'inventory/assets/gap_report': 'GAP Report',
  'inventory/assets/uth_lws_report': 'UTH LWS Report',
  'inventory/assets/uth_epr_report': 'UTH EPR Report',
  'inventory/assets/lws_changes_report': 'LWS Changes Report',
  'inventory/workflows/workflow_reqs_report': 'Primary Use Requirements',
  'inventory/workflows/clinic_summary_report': 'Clinic Inventory Summary',
  'inventory/dropdowns/bulk_update': 'Dropdowns List Bulk Update',
  'inventory/states/bulk_update': 'States Bulk Update',
  'inventory/cities/bulk_update': 'Cities Bulk Update',
  'inventory/buildings/bulk_update': 'Buildings Bulk Update',
  'inventory/ous/bulk_update': 'OUs Bulk Update',
  'inventory/specialties/bulk_update': 'Specialties Bulk Update',
  'inventory/departments/bulk_update': 'Departments Bulk Update',
  'inventory/workflows/bulk_update': 'Primary Uses Bulk Update',
  'inventory/workflows/default_reqs_bulk_update': 'Workflow Default Reqs Bulk Update',
  'inventory/assets/bulk_update': 'Assets Bulk Update',
  'inventory/assets/workstations_bulk_update': 'Workstations Bulk Update',
  'inventory/assets/leased_assets_bulk_update': 'Leased Assets Bulk Update',
};

export const SETTING_GROUPS = {
  'GROUP_EPIC': 'epic',
  'GROUP_SERVICE_NOW': 'service_now',
  'GROUP_SAML_AUTH': 'saml_auth',
  'GROUP_AZURE_AUTH': 'azure_auth',
};

export const SETTING_GROUPS_LABELS = {
  'epic': 'EPIC',
  'service_now': 'ServiceNow',
  'saml_auth': 'SAML Authentication',
  'azure_auth': 'Azure AD',
};

export const SETTING = {
  'EPIC_API_BASE_URL': 'epic/api_base_url',
  'EPIC_API_CLIENT_ID': 'epic/api_client_id',
  'EPIC_API_USER_ID': 'epic/api_user_id',
  'EPIC_API_USER_ID_TYPE': 'epic/api_user_id_type',
  'EPIC_API_CLIENT_PRIVATE_KEY': 'epic/api_client_private_key',
  'SERVICE_NOW_BASE_URL': 'service_now/api_base_url',
  'SERVICE_NOW_CLIENT_ID': 'service_now/api_client_id',
  'SERVICE_NOW_CLIENT_SECRET': 'service_now/api_client_secret',
  'SERVICE_NOW_USERNAME': 'service_now/username',
  'SERVICE_NOW_PASSWORD': 'service_now/password',
  'SAML_AUTH_ENTITY_ID': 'saml_auth/entity_id',
  'SAML_AUTH_METADATA_URL': 'saml_auth/metadata_url',
  'SAML_AUTH_ATTRIBUTE_MAP_UID': 'saml_auth/attribute_map_uid',
  'SAML_AUTH_ATTRIBUTE_MAP_EMAIL': 'saml_auth/attribute_map_email',
  'SAML_AUTH_ATTRIBUTE_MAP_FIRST_NAME': 'saml_auth/attribute_map_first_name',
  'SAML_AUTH_ATTRIBUTE_MAP_LAST_NAME': 'saml_auth/attribute_map_last_name',
  'SAML_AUTH_ATTRIBUTE_MAP_USERNAME': 'saml_auth/attribute_map_username',
  'AZURE_AUTH_ENTITY_ID': 'azure_auth/entity_id',
  'AZURE_AUTH_METADATA_URL': 'azure_auth/metadata_url',
};

export const SETTING_LABELS = {
  'epic/api_base_url': 'EPIC API Base URL',
  'epic/api_client_id': 'EPIC API Client ID',
  'epic/api_user_id': 'EPIC API User ID',
  'epic/api_user_id_type': 'EPIC API User ID Type',
  'epic/api_client_private_key': 'EPIC API Client Private Key',
  'service_now/api_base_url': 'ServiceNow Base URL',
  'service_now/api_client_id': 'ServiceNow Client ID',
  'service_now/api_client_secret': 'ServiceNow Client Secret',
  'service_now/username': 'ServiceNow Username',
  'service_now/password': 'ServiceNow Password',
  'saml_auth/entity_id': 'SAML Entity ID',
  'saml_auth/metadata_url': 'SAML Metadata URL',
  'saml_auth/attribute_map_uid': 'SAML Attribute Map UID',
  'saml_auth/attribute_map_email': 'SAML Attribute Map Email',
  'saml_auth/attribute_map_first_name': 'SAML Attribute Map First Name',
  'saml_auth/attribute_map_last_name': 'SAML Attribute Map Last Name',
  'saml_auth/attribute_map_username': 'SAML Attribute Map Username',
  'azure_auth/entity_id': 'Entity ID',
  'azure_auth/metadata_url': 'Metadata URL',
};

export const DEPARTMENT_SCOPES = {
  'IN_EPIC_SCOPE': 'in_epic_scope',
  'OUT_EPIC_SCOPE': 'out_epic_scope',
};

export const DEPARTMENT_SCOPES_LABELS = {
  'in_epic_scope': 'In EPIC Scope',
  'out_epic_scope': 'Out of EPIC Scope',
};

export const DROPDOWN_TYPES = {
  'MAKE': 'make',
  'MODEL': 'model',
  'OS': 'os',
  'SIZE': 'size',
  'RESOLUTION': 'resolution',
  'SCREEN_ORIENTATION': 'screen_orientation',
};

export const DROPDOWN_TYPES_LABELS = {
  'make': 'Make',
  'model': 'Model',
  'os': 'OS',
  'size': 'Size',
  'resolution': 'Resolution',
  'screen_orientation': 'Screen Orientation',
};

export const INFORMATION_STATUSES = {
  'INCOMPLETE': 'incomplete',
  'COMPLETE': 'complete',
};

export const INFORMATION_STATUSES_LABELS = {
  'incomplete': 'Incomplete',
  'complete': 'Complete',
};

export const DEPARTMENT_STATUSES = {
  'ACTIVE': 'active',
  'INACTIVE': 'inactive',
  'EPIC_PHASE_2': 'epic_phase_2',
  'OUT_EPIC_SCOPE': 'out_epic_scope',
  'OUT_SCOPE': 'out_scope',
};

export const DEPARTMENT_STATUSES_LABELS = {
  'active': 'Active',
  'inactive': 'Inactive',
  'epic_phase_2': 'EPIC Phase 2',
  'out_epic_scope': 'Out of EPIC Scope',
  'out_scope': 'Out of Scope',
};

export const ASSET_STATUSES = {
  'ACTIVE': 'active',
  'LEASE_RETURN': 'lease_return',
  'INACTIVE': 'inactive',
  'SENT_SURPLUS': 'sent_surplus',
};

export const ASSET_STATUSES_LABELS = {
  'active': 'Active',
  'lease_return': 'Lease Return',
  'inactive': 'Inactive',
  'sent_surplus': 'Send to Surplus',
};

export const LOGIN_STRATEGIES = {
  'SHARED': 'shared',
  'NOT_SHARED': 'not_shared',
};

export const LOGIN_STRATEGIES_LABELS = {
  'shared': 'Shared',
  'not_shared': 'Not Shared',
};

export const FRONT_END_SAML_FINISH_URL = '/saml-auth-finish';

export const SAML_START_LOGIN_URL = '/accounts/saml/app-in/login/';
export const SAML_ACS_FINISH_URL = '/accounts/saml/app-in/acs/finish/';
